// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-task-v2-current-location-info .fa-regular:before {
  font-size: 12px;
}

.tooltip.task-current-location-tooltip-content {
  max-width: 250px;
}`, "",{"version":3,"sources":["webpack://./Source/app/task-v2/components/fi-task-v2-current-location-info/fi-task-v2-current-location-info.component.scss"],"names":[],"mappings":"AACI;EACI,eAAA;AAAR;;AAIA;EACI,gBAAA;AADJ","sourcesContent":[".fi-task-v2-current-location-info {\r\n    .fa-regular:before {\r\n        font-size: 12px;\r\n    }\r\n}\r\n\r\n.tooltip.task-current-location-tooltip-content {\r\n    max-width: 250px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
